var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legal-page"},[(_vm.get_correct_page === 'privacy-policy')?_c('privacy_policy'):_vm._e(),(_vm.get_correct_page === 'return-policy')?_c('return_policy'):_vm._e(),(_vm.get_correct_page === 'terms-and-conditions')?_c('terms_and_conditions'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }